import React, { useState, useEffect, useRef } from 'react';
import { getAllUsersDetails,createUser } from '../../redux/actions/authActions';
import { validateEmail } from '../../utils/helperFuntions';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Grid,CircularProgress} from '@mui/material';
import './Styles.scss';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';  

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import axios from 'axios';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import EditNoteIcon from '@mui/icons-material/EditNote';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Switch, FormControlLabel } from "@mui/material";
import PageLoaderComp from '../pageLoaderComp';
import ConfirmDialog from '../ConfirmDialog';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

const ActionCell = ({ params, user, onActionClick, ITEM_HEIGHT, options, selectedOption }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openEl, setOpenEl] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenEl(true);
  };

  const handleCloseEl = () => {
    setAnchorEl(null);
    setOpenEl(false);
  };

  if (!user || user.role !== 'ROLE_ADMIN') {
    return null;
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={openEl ? 'long-menu' : undefined}
        aria-expanded={openEl ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={openEl}
        onClose={handleCloseEl}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch',
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem 
            key={option} 
            selected={option === selectedOption}
            onClick={(e) => {
              onActionClick(e, option, params.row);
              handleCloseEl();
            }}
          >
            {option === "Delete" ? <DeleteIcon sx={{ color: 'red' }} /> : ""}
            {option === "Edit" ? <EditNoteIcon sx={{ color: 'green' }} /> : ""}
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

function UsersComp() {
    const [pageLoading, setPageLoading] = useState(false);
    const [isActive, setIsActive] = useState(true); // State for the switch
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const dispatch = useDispatch();
    const { loading, all_users, auth_token, user } = useSelector((state) => state.auth);
    
    const handleActionClick = (evt, option, rowData) => {
        setSelectedOption(option);
        
        if(option === "Delete"){
            setConfirmDialogOpen(true);
        }else if(option === "Edit"){
            // Edit logic will be implemented later
        }
    };
    
    const handleConfirmDelete = () => {
        setConfirmDialogOpen(false);
    };

    const handleCancelDelete = () => {
    setConfirmDialogOpen(false);
    };
    
  const [formData, setFormData] = useState({
    "firstName": "",
    "lastName": "",
    "email": "",
    "status": isActive,
    "role": "ROLE_ADMIN"
  });

const [open, setOpen] = useState(false);
const [buttonLoading, setButtonLoading] = useState(false);
const [selectedOption, setSelectedOption] = useState('');
const [isSubmitted, setIsSubmitted] = useState(false);
const isFetched = useRef(false);

const handleToggle = (event) => {
    setIsActive(event.target.checked);
    setFormData({
        ...formData,
        ['status']: event.target.checked,
      });
  };
const options = [
    "Edit",
    "Delete",
];
const ITEM_HEIGHT = 48;

const getColumns = (user, selectedOption, handleActionClick) => [
    { field: 'firstName', headerName: 'First name', width: 280 },
    { field: 'lastName', headerName: 'Last name', width: 280 },
    { field: 'role', headerName: 'Role', width: 200 },
    { field: 'email', headerName: 'Email', width: 400 },
    { 
        field: 'status', 
        headerName: 'Status', 
        width: 100, 
        renderCell: (params) => (
            <span style={{ color: params.value ? 'green' : 'red' }}>
                {params.value ? 'Active' : 'Inactive'}
            </span>
        )
    },
    { 
        headerName: 'Action', 
        width: 100, 
        renderCell: (params) => (
            <ActionCell 
                params={params}
                user={user}
                onActionClick={handleActionClick}
                ITEM_HEIGHT={ITEM_HEIGHT}
                options={options}
                selectedOption={selectedOption}
            />
        )
    },
  ];
  
  const paginationModel = { page: 0, pageSize: 10 };
  

useEffect(() => {
    if (auth_token && !isFetched.current) {
        const getAllUsersFunc = async () => {
            setPageLoading(true);
            await dispatch(getAllUsersDetails());
            isFetched.current = true;
            setPageLoading(false);
        };

        getAllUsersFunc();
    }
}, [auth_token, dispatch]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleChange = (event) => {
    setFormData({
        ...formData,
        [event.target.name]: event.target.value,
      });
  };
  const handleSubmit =async () => {
    setIsSubmitted(true);
    if(formData.firstName && formData.lastName && formData.email && validateEmail(formData.email)){
        setButtonLoading(true)
        const data = await dispatch(createUser(formData));  
        
        setButtonLoading(false)
        if(data.success){
            dispatch(getAllUsersDetails());
            handleClose(false);
        }
       
    }
  };
  const columns = getColumns(user, selectedOption, handleActionClick);

  return (
    <>
    <Box className="rightContainer">
        {pageLoading && <PageLoaderComp />}
        <Grid container spacing={2}
        
        sx={{
        justifyContent: "center",
        alignItems: "center",
        }}
        >
            <Grid item xs={6}>
                <Typography component="h1" variant="h5" mb={0} mt={0}>
                User list
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Item className='text-right'><Button
                    variant={'contained'}
                    sx={{ marginBottom:"5px" }}
                    onClick={handleClickOpen} > Add User</Button></Item>
            </Grid>
        </Grid>


        <Paper sx={{ height: 500, width: '100%' }}>
            <DataGrid
                rows={all_users}
                columns={columns}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[10,20]}
                checkboxSelection={false}
                sx={{ 
                  '& .MuiDataGrid-columnHeader': {
                    backgroundColor: 'rgba(0, 0, 0, 0)', 
                    color: 'black', 
                    fontSize: '16px', 
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#dee7de', 
                    color: 'black', 
                    fontSize: '16px', 
                  },
                  '& .MuiDataGrid-row--borderBottom': {
                    backgroundColor: 'rgba(0, 0, 0, 0) !important', 
                    color: 'black', 
                    fontSize: '16px', 
                  },
                  border: 0 
                }}
            />
        </Paper>
    </Box>
        <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "20px",
          },
        }}
      >
        <Box sx={{padding:'10px'}} >
        <DialogTitle>Add User</DialogTitle>
        <DialogContent>
          <FormControl fullWidth variant="standard" sx={{ mt: 1, mb: 1, minWidth: 120 }}>
                <InputLabel id="demo-simple-select-label">User Role</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={formData.role}
                name={'role'}
                error={isSubmitted && !formData.role?true:false}
                label="User Role"
                onChange={handleChange}
                >
                    <MenuItem value={"ROLE_ADMIN"}>Admin</MenuItem>
                    <MenuItem value={"ROLE_STAFF"}>Staff</MenuItem>
                    <MenuItem value={"ROLE_CLIENT"}>Client</MenuItem>
                </Select>
            </FormControl>
          <TextField
            autoFocus
            required
            margin="dense"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            label="First Name"
            type="text"
            fullWidth
            variant="standard"
            error={isSubmitted && !formData.firstName?true:false}
            onChange={handleChange}
          />
          <TextField
            autoFocus
            required
            margin="dense"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            label="Last Name"
            type="text"
            fullWidth
            variant="standard"
            error={isSubmitted && !formData.lastName?true:false}
            onChange={handleChange}
          />
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="email"
            value={formData.email}
            label="Email Address"
            type="email"
            fullWidth
            variant="standard"
            error={isSubmitted && (!formData.email || !validateEmail(formData.email))?true:false}
            onChange={handleChange}
          />
          <Box className="status-item">
          <div>Status</div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <FormControlLabel
        control={
          <Switch
            checked={isActive}
            onChange={handleToggle}
            color="primary"
          />
        }
        label={
          <Typography
            style={{
              color: isActive ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {isActive ? "Active" : "Inactive"}
          </Typography>
        }
      />
    </div>

      
          </Box>
        </DialogContent>
        <DialogActions>
        <Button variant={'contained'} type="button" onClick={handleSubmit}>
            {buttonLoading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Add'}
        </Button>
          <Button variant={'outlined'} onClick={handleClose}>Cancel</Button>
        </DialogActions>
        </Box>
        </Dialog>

        <ConfirmDialog
            open={confirmDialogOpen}
            title="Confirm Delete"
            message="Are you sure you want to Delete?"
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
            buttonLoading={false}
        />
    
    </>
    
  );
}

export default UsersComp;
